<template>
	<div>
		<headers></headers>
		<div class="py-4 px-4">
			<div class="ft16 ftw600">
				通知列表
			</div>
			<div class=" m-3" style="height: 300px;overflow-y: scroll;">
				<div class="flex wrap">
					<div class="mt-2 bg-w ml15 br12 p-2" style="border: 1px solid #c7c7c7;height: 80px;"
						v-for="(item,index) in messageList">
						<!-- 课堂确认 -->
						<div class="flex wid-300" v-if="item.type == 1" @click="toPage('/students?index=1')">
							<img src="../../assets/image/header_icon1.png" alt="" class="header-icon" style="" />
							<div>
								<div class="ft16">我的課堂</div>
								<div class="ft14">你有一個課堂預約未確認</div>
								<div class="ft14">{{item.updatetime}}</div>
							</div>
							<div class="header-dot"></div>
						</div>
						<!-- 附录查看 作业 -->
						<div class="flex wid-300" v-if="item.type == 2" @click="toPage('/students?index=3')">
							<img src="../../assets/image/header_icon2.png" alt="" class="header-icon" />
							<div>
								<div class="ft16"> 我的作業</div>
								<div class="ft14">老師剛上傳了一份作業</div>
								<div class="ft14">{{item.updatetime}}</div>
							</div>
							<div class="header-dot"></div>
					
						</div>
						<!-- 学习报告 -->
						<div class="flex wid-300" v-if="item.type == 3" @click="toPage('/students?index=5')">
							<img src="../../assets/image/header_icon3.png" alt="" class="header-icon" />
							<div>
								<div class="ft16">學習報告</div>
								<div class="ft14">老師給你了一份學習報告</div>
								<div class="ft14">{{item.updatetime}}</div>
							</div>
							<div class="header-dot"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="ft16 ftw600">
				訊息列表
			</div>
			<div class=" m-3" style="height: 300px;overflow-y: scroll;">
				<div class="flex wrap">
					<div class="flex mt-2 bg-w ml15 br12 p-2 wid-300"  style="border: 1px solid #c7c7c7;height: 80px;" @click="openKefu(item.sender_id)" v-for="(item,index) in fastimList">
						<img :src="item.avatar" alt="" class="header-icon" style="" />
						<div>
							<div class="ft16">{{item.nickname}}</div>
							<div class="ft14 text-over" style="width: 150px;">{{item.message}}</div>
							<div class="ft14">{{formatTimestamp(item.createtime) }}</div>
						</div>
						<div class="header-dot"></div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				messageList: [],
				fastimList: []
			}
		},
		created() {
			this.getUserMessageList()
			this.getFastimMessage()
		},
		methods: {
			// 获取消息,系统内部
			getUserMessageList() {
				this.$http.api('user/userMessageList', {
					page: 1,
					limit: 100
				}).then(res => {
					this.messageList = res.list
				})
			},
			getFastimMessage() {
				this.$http.api('plugin/fastim/messageList', {
					// status:0,//状态:0=未读,1=已读,2=发送中,3=隐藏状态,4=失败
					page: 1,
					limit: 100,
				}).then(res => {
					this.fastimList = res.list
				})
			},
			formatTimestamp(timestamp) {
			  // 转换为毫秒级时间戳
			  const date = new Date(timestamp * 1000);
			  
			  const year = date.getFullYear();
			  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要加1
			  const day = String(date.getDate()).padStart(2, '0');
			  const hours = String(date.getHours()).padStart(2, '0');
			  const minutes = String(date.getMinutes()).padStart(2, '0');
			  const seconds = String(date.getSeconds()).padStart(2, '0');
			  
			  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			toPage(path) {
				this.$router.push(path)
			}
		}
	}
</script>

<style>
	.wid-300 {
		width: 300px;
	}

	.header-icon {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin-right: 10px;
	}

	.header-dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background-color: #ea5346;
		margin-left: 50px;
		margin-top: 20px;
	}
</style>